// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"cf83ab7a","1449":"011d426b","4130":"346a5a76","6302":"011d426b","8187":"011d426b","9658":"011d426b"}[chunkId] + ".chunk.css";
};